'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.weak-set.constructor');



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/modules/es.weak-set.js
// module id = 143
// module chunks = 0